import * as React from "react";

import { SxProps, styled, Box, Stack, IconButton, Typography } from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

export interface PanelHeaderProps {
  sx?: SxProps;
  children?: React.ReactNode;
  title?: string;
  leftContent?: React.ReactNode;
  rightContent?: React.ReactNode;
  onClose?: () => void;
  placement?: "right" | "left";
  type?: "transparent" | "full";
  opening?: "nested" | "new";
}
const PanelHeader: React.FC<PanelHeaderProps> = (props) => {
  const {
    onClose,
    title,
    leftContent,
    rightContent,
    children,
    placement = "right",
    type = "full",
    opening = "new",
    ...otherProps
  } = props;
  const closeIcon = React.useMemo(
    () => (
      <IconButton size="small" color="ghost" aria-label="close" onClick={onClose}>
        {opening === "nested" ? <ArrowBackIcon /> : <CloseRoundedIcon />}
      </IconButton>
    ),
    [opening, onClose]
  );
  return (
    <Header placement={placement} type={type} {...otherProps}>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Stack direction="row" alignItems="center" spacing={1}>
          {placement === "right" && closeIcon}
          {title && <Typography variant="h5">{title}</Typography>}
          {leftContent}
        </Stack>
        <Stack direction="row" alignItems="center" spacing={1.5}>
          {rightContent}
          {placement === "left" && closeIcon}
        </Stack>
      </Stack>
      {children && <Box pt={2}>{children}</Box>}
    </Header>
  );
};

const Header = styled(Stack, { shouldForwardProp: (prop) => prop !== "placement" && prop !== "type" })<{
  placement: PanelHeaderProps["placement"];
  type: PanelHeaderProps["type"];
}>(({ theme, placement, type }) => ({
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),
  paddingLeft: placement === "left" ? theme.spacing(2) : theme.spacing(1),
  paddingRight: placement === "right" ? theme.spacing(2) : theme.spacing(1),
  //   borderBottom: type === "transparent" ? "none" : `1px solid ${theme.palette.backgroundAlpha.border}`,
  background: type === "transparent" ? "none" : theme.palette.background.default,
  position: "sticky",
  top: 0,
  zIndex: 2,
  boxSizing: "border-box",
}));

export default PanelHeader;
